<template>
  <div class="home">
	  
	      
	      
	       

		  <div class="container is-fluid">
			   <div class="notification is-success" v-if="loading === true">
						Loading organisation data
					</div>
               <div v-if="loading === false">
                
                <div class="level">
                    <div class="level-left">
                        <h2 class="title">Organisation Details</h2>
                    </div>
                   
                </div>
                <div class="box">	
                 

                    <div class="field">
                        <label class="label">Name</label>
                        <div class="control">
                            <input class="input" type="text" readonly v-model="organisation.name"  required>
                            
                        </div>
                    </div>
                   
                </div>
            </div>
                
            <br />
            <div class="level" v-if="loading === false">
                    <div class="level-left">
                        <h2 class="title">Users</h2>
                    </div>
                    <div class="level-right">
                        <router-link :to="'/add_organisation_user/' + this.$route.params.id" class="button is-success" style="">Add New User to Organisation</router-link>
                        </div>
                   
            </div>
            <div class="box" v-if="loading === false">	
                <div class="notification is-warning" v-if="loading === false && organisation.users.length == 0">
                   No users have been linked to this organisation yet
                </div>
                <table class="table is-fullwidth" v-if="loading === false && organisation.users.length > 0">
                     <thead>
                   <tr>
                       <th>First Name</th>
                        <th>Surname</th>
                        <th>Email</th>
                        <th width="50">&nbsp;</th>
                       </tr>
                   </thead>
				   <tbody>
					   <tr v-for="row in  organisation.users" :key="row.id">
						   <td>{{ row.forename }}</td>
						    <td>{{ row.surname }}</td>
                            <td>{{ row.email }}</td>
                            <td>
                                <button class="button is-small is-success" v-if="row.auth0 != ''"><span>Login Already Setup</span></button>

                            </td>
						   </tr>
					</tbody>
                   
                </table>
                   
             </div>


             <br />
            <div class="level" v-if="loading === false">
                    <div class="level-left">
                        <h2 class="title">Hours</h2>
                    </div>
                    <div class="level-right">
                        <router-link :to="'/record_hours/' + this.$route.params.id" class="button is-success" style="display:none">Record Hours</router-link>
                        </div>
                   
            </div>
            <div class="box" v-if="loading === false">	
                <div class="notification is-warning" v-if="loading === false && organisation.hours.length == 0">
                   No hours have been recorded for this organisation yet
                </div>
                <table class="table is-fullwidth" v-if="loading === false && organisation.hours.length > 0">
                     <thead>
                   <tr>
                       <th>Volunteer</th>
                        <th>Date</th>
                        <th>Hours</th>
                       </tr>
                   </thead>
				   <tbody>
					   <tr v-for="row in  organisation.hours" :key="row.id">
						   <td>{{ row.forename }} {{ row.surname}}</td>
						    <td>{{ row.date }}</td>
                            <td>{{ row.hours }}</td>
						   </tr>
					</tbody>
                    
                </table>
                   
             </div>

           

             <br />
            <div class="level" v-if="loading === false">
                    <div class="level-left">
                        <h2 class="title">Volunteers</h2>
                    </div>
                    <div class="level-right">
                        <router-link :to="'/record_hours/' + this.$route.params.id" class="button is-success" style="display:none">Record Hours</router-link>
                        </div>
                   
            </div>
            <div class="box" v-if="loading === false">	
                <div class="notification is-warning" v-if="loading === false && organisation.volunteers.length == 0">
                   No volunteers have been linked to this organisation yet
                </div>
                <table class="table is-fullwidth" v-if="loading === false && organisation.volunteers.length > 0">
                     <thead>
                   <tr>
                       <th>First Name</th>
                        <th>Surname</th>
                        <th>Hours</th>
                       </tr>
                   </thead>
				   <tbody>
					   <tr v-for="row in  organisation.volunteers" :key="row.id">
						   <td>{{ row.forename }}</td>
						    <td>{{ row.surname }}</td>
                            <td>{{ row.total_hours}}</td>
						   </tr>
					</tbody>
                   
                </table>
                   
             </div>
				 
					
                   
			
             
        </div>	   
	</div>
</template>

<script>
//import AwardsService from '@/services/AwardsService.js';
import AwardsMixin from '@/mixins/AwardsMixin.js';
export default {
  name: 'ViewEvent',
	mixins: [AwardsMixin],
	data: function () {
    	return {
		      organisation: {users:[], volunteers: [], hours: []},
			  loading : true,
			  search: "",
                API_NAME: process.env.VUE_APP_API_NAME,
                
		}
	},
	created() {
		this.getAccessToken()
        .then(() => { 
            this.getOrganisation();
        });
		
	},
	methods: {
		async getAccessToken() {
            this.accessToken = await this.$auth.getTokenSilently()
        },
		
		
		
	}
}
</script>

<style scoped>

.activeRow {background:#ddd}
</style>
